import contentful from '@client/util/contentful';
import {Logger, Category} from '@simpleinvest/front-end-logger';

const logger = new Logger({
  category: Category.Cms,
  fileName: 'faqs.js',
});

const initialState = {
  contentType: 'helpFaq',
  faqs: [],
};

const getters = {
  faqs: (state) => state.faqs,
};

const actions = {
  async getFaqs({state, commit}, filters) {
    let items = [];

    try {
      const contentfulEntries = await contentful.client().getEntries({content_type: state.contentType, ...filters});

      items = contentfulEntries.items;
    } catch {
      logger.addBreadcrumb({
        callingFuncName: 'getFaqs',
        message: `Contentful fetch error caught`,
      });
    }

    const faqs = items.map((item) => ({
      id: item.sys.id,
      ...item.fields,
    }));

    commit('setFaqs', faqs);

    return faqs;
  },
};

const mutations = {
  setFaqs(state, faqs) {
    state.faqs = faqs;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
